@if (showWrongGameMessage) {
  {{ wrongGameIdMessage }}
} @else {
  @if (newGame$ | async; as newGame) {
    <h2>Game Name: {{ newGame.newBaseGameSettings?.name }}</h2>
    <h2>Subdomain: {{ newGame.newBaseGameSettings?.subdomain }}</h2>
    <button mat-fab class="save-game" data-testid="save-draft-button" (click)="saveGame()">
      <mat-icon>save</mat-icon>
    </button>
    <mat-vertical-stepper #stepper>
      <mat-step>
        <ng-template matStepLabel data-testid="general-settings-step">General Settings</ng-template>
        <div class="padding-top-med padding-bottom-med">
          <app-general-game-settings-form
            (newGameGeneralSettingsFormChange)="gameGeneralForm = $event"></app-general-game-settings-form>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel data-testid="draw-settings-step">Draw Settings</ng-template>
        <div class="padding-top-med padding-bottom-med">
          <app-game-draw-settings-form
            (newGameDrawSettingsFormChange)="gameDrawSettingsForm = $event"></app-game-draw-settings-form>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel data-testid="notification-settings-step">Notification Settings</ng-template>
        <div class="padding-top-med padding-bottom-med">
          <app-game-notification-settings-form
            (newGameNotificationSettingsFormChange)="gameNotificationSettingsForm = $event">
          </app-game-notification-settings-form>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel data-testid="payment-settings-step">Payment Settings</ng-template>
        <div class="padding-top-med padding-bottom-med">
          <app-game-payment-settings-form
            (newGamePaymentFormChange)="gamePaymentSettingsForm = $event"></app-game-payment-settings-form>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel data-testid="metadata-settings-step">Metadata Settings</ng-template>
        <div class="padding-top-med padding-bottom-med">
          <app-game-metadata-settings-form
            (newGameMetadataSettingsFormChange)="gameMetadataSettingsForm = $event"></app-game-metadata-settings-form>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel data-testid="assets-settings-step">Assets Settings</ng-template>
        <div class="padding-top-med padding-bottom-med">
          <app-game-asset-settings-form
            (newGameAssetsSettingsFormChange)="gameAssetsSettingsForm = $event"></app-game-asset-settings-form>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel data-testid="add-charities-step">Add Charities</ng-template>
        @if ((charitiesForNewGame$ | async); as charityCategories) {
          @if (charityCategories.length > 0) {
            @for (charityCategory of charityCategories; track charityCategory) {
              <div class=" margin-bottom-med">
                <div class="bold-text">Category: {{ charityCategory.Category.Name }}</div>
                @for (charity of charityCategory.Charities; track charity) {
                  <div class="margin-left-small margin-top-small">- {{ charity.Name }}</div>
                }
                @if (charityCategory.Charities.length === 0) {
                  <div class="margin-top-med">You must add at least one charity to your category.</div>
                }
              </div>
            }

          } @else {
            <div class="margin-top-med">You must add at least one charity category and charity to your game.</div>
          }
        }

        <div class="padding-top-med padding-bottom-med">
          <button mat-button color="primary" data-testid="add-charities-button" (click)="addNewCharities()">Add
            Charities
          </button>
        </div>

      </mat-step>
      <mat-step>
        <ng-template matStepLabel data-testid="add-game-rules-step">Add Game Rules</ng-template>
        <h3>Game Rules Input</h3>

        <div class="rules-section margin-bottom-large">
          <form [formGroup]="gameRulesForm">
            <mat-form-field class="full-width">
              <mat-hint>game rules are written in markdown. Input your markdown here, and the preview below will show
                the
                final product
              </mat-hint>
              <textarea matInput formControlName="gameRules" rows="20" data-testid="new-game-rules-input"></textarea>
              @if (gameRulesControl.errors) {
                <mat-error>Game rules are required</mat-error>
              }
            </mat-form-field>
          </form>
        </div>

        <hr>

        <h3>Game Rules Preview</h3>

        <div class="markdown-preview rules-section padding-med">
          <markdown [data]=formatMarkdown(gameRulesControl.value!)></markdown>
        </div>

        <br>

        <div class="padding-top-med padding-bottom-med">
          @if(gameRulesAlreadyExist) {
            <button mat-button color="primary" data-testid="edit-game-rules-button" (click)="editGameRules()">Edit
              Game Rules
            </button>
          }@else {
            <button mat-button color="primary" data-testid="add-game-rules-button" (click)="addNewGameRules()">Add
              Game Rules
            </button>
          }

        </div>

      </mat-step>
      <mat-step>
        <ng-template matStepLabel data-testid="payment-tiers-step">Payment Tiers</ng-template>
        @if (gameGeneralForm.controls.type.value === GameTypeEnum.GoldRush) {
          <app-edit-payment-tiers-goldrush [gameSetter]="inProgressDraftGame"></app-edit-payment-tiers-goldrush>
        } @else if (gameGeneralForm.controls.type.value === GameTypeEnum.ProgressiveFiftyFifty) {
          <app-edit-payment-tiers-fifty-fifty [gameSetter]="inProgressDraftGame"></app-edit-payment-tiers-fifty-fifty>
        } @else {
          <mat-error class="margin-top-med">You must choose a game type from the general setting tabs before adding your
            payment tiers.
          </mat-error>
        }
      </mat-step>
      <mat-step>
        <ng-template matStepLabel data-testid="lottery-license-step">Lottery License</ng-template>
        <div class="padding-top-med padding-bottom-med">
          @if (lotteryLicense == null) {
            <div>Please add a lottery license to the game</div>
            <button mat-raised-button
                    data-testid="add-new-licence-number-button"
                    color="primary"
                    (click)="openAddLicenceNumber()"
                    matTooltip="add new licence number"
                    matTooltipShowDelay="500"> Add
              <mat-icon>add_circle</mat-icon>
            </button>
          } @else {
            <p>License #: {{lotteryLicense.LicenceNumber}}</p>
            <p>Starts on: {{lotteryLicense.StartDate | date: 'MMM dd yyyy'}}</p>
            @if (lotteryLicense.EndDate) {
              <p>Ends on: {{lotteryLicense.EndDate | date: 'MMM dd yyyy'}}</p>
            }
            <button mat-raised-button
                    data-testid="edit-licence-number-button"
                    color="primary"
                    (click)="openEditLicenceNumber()"
                    matTooltip="add new licence number"
                    matTooltipShowDelay="500"> Edit
              <mat-icon>edit_circle</mat-icon>
            </button>
          }
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel data-testid="validate-and-complete-draft-step">Validate & Complete Draft</ng-template>

        @if (allowCreationOfAzureResources) {
          <div class="padding-top-med padding-bottom-med">
            <mat-checkbox [(ngModel)]="createAzureResources" [checked]="createAzureResources">Create Azure Resources</mat-checkbox>
          </div>
        }
        <div class="padding-top-med padding-bottom-med">
          <button mat-stroked-button color="primary" data-testid="validate-game-button" (click)="onValidateGameClick()">
            @if (uiState === uiStateEnumForTemplate.ShowRequestProcessing) {
              <mat-spinner diameter="32" color="accent"></mat-spinner>
            } @else {
              Validate and Finalize Game
            }
          </button>
        </div>

        @for (error of validationErrors; track error) {
          <div class="margin-bottom-med">- {{ error }}</div>
        }

      </mat-step>
    </mat-vertical-stepper>
  }

}
